import React, { useState, useRef, useEffect } from 'react';
import CustomButtonName from '@React_UI_Lib/Button';
import * as S from './coach-mark.styles';

const Coachmark = ({ children, width, data, handleTracking, setNudgeToShow }) => {
  const { title, description, cta, tracking } = data;
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const targetRef = useRef(null);
  const coachMarkRef = useRef(null);

  useEffect(() => {
    if (handleTracking) {
      handleTracking(tracking);
    }
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (isVisible && targetRef.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      const coachMarkRect = coachMarkRef.current.getBoundingClientRect();
      setPosition({
        top: targetRect.height + 12,
        left: -(coachMarkRect.width / 2) + targetRect.width / 2
      });
      setTimeout(() => {
        if (targetRef.current?.scrollIntoView) {
          targetRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });
        }
      }, 2000);
    }
  }, [isVisible]);

  const hideCoachmark = () => {
    setIsVisible(false);
    setNudgeToShow(null);
  };

  return (
    <>
      <S.Overlay isVisible={isVisible} onClick={hideCoachmark} />
      <S.TargetElement ref={targetRef} onClick={hideCoachmark}>
        {children}
        {isVisible && (
          <S.CoachmarkContainer
            ref={coachMarkRef}
            isVisible={isVisible}
            width={width}
            top={position.top}
            left={position.left}
          >
            <div className="font16 f600" dangerouslySetInnerHTML={{ __html: title }}></div>
            <div
              className="greyCntLt marginT5 font14"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <S.ButtonWrap className="marginT10">
              <CustomButtonName
                content={cta?.text}
                customClass="font14 f500 coachMarkBtn"
                variant="secondary"
                theme="isGi"
                noShadow="noShadow"
                isUpperCase={false}
                handleClick={() => {
                  hideCoachmark();
                  if (handleTracking) {
                    handleTracking(cta?.tracking);
                  }
                }}
              />
            </S.ButtonWrap>
          </S.CoachmarkContainer>
        )}
      </S.TargetElement>
    </>
  );
};

export default Coachmark;
